import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  isShowGlobalLoading = signal(false);

  #allowUrl = ['/order', '/account'];

  queue: Map<string, boolean> = new Map();

  constructor() { }

  validateEndPoint(url: string) {
    if (!this.#allowUrl.some(x => url.includes(x)))
      return;

    this.open(url);
  }

  close(url: string) {
    this.queue.delete(url);
    if (this.queue.size === 0)
      this.isShowGlobalLoading.set(false);
  }

  open(url: string) {
    this.queue.set(url, true);
    this.isShowGlobalLoading.set(true);
  }
}
